import {updateDisplayedPrices} from "./updateDisplayedPrices";
import {isMaxUser} from "../utils";
import {getSelectedDisplayValues, extractProductTilesToFetchPrices} from "./priceUtils";
import {setButtonEnabledState} from "../add-to-cart";

const checkForParentNode = (element: HTMLElement, event: Event, boundFunction: Function, parentNode: ?Boolean ) => {
  if (parentNode){
    element.parentNode.addEventListener(event, boundFunction);
  } else {
    element.addEventListener(event, boundFunction);
  }
}

const addEventListenerTriggers = (win: WindowProxy, productTile: HTMLElement) =>
  (elements: Node | NodeList, event: Event, parentNode: ?Boolean) => {
    const boundFunction = priceChange.bind(null, win, productTile);
    if(elements instanceof NodeList){
      elements.forEach((element: Node) => checkForParentNode(element, event, boundFunction, parentNode));
    } else {
      checkForParentNode(elements, event, boundFunction, parentNode);
    }
  };

const priceChange = (win: WindowProxy, productTile: HTMLElement) => {
  const {showGstInclusive, displayPricesOption} = getSelectedDisplayValues(win);
  const quantity = 1;
  const pack = isMaxUser(win) ? productTile.querySelector(`.product-tile__unit-switch-radio:checked`).value : '1';
  const productCode = productTile.dataset.productCode;

  updateDisplayedPrices(win, productCode, quantity, pack, showGstInclusive, displayPricesOption);
  setButtonEnabledState(productTile, pack);
};

export function addUpdateDisplayedPriceEvents(win: WindowProxy) {
  extractProductTilesToFetchPrices(win).forEach(productTile => {
    //init Listener Function
    const addListeners = addEventListenerTriggers(win, productTile);
    // addUomChangeEvents;
    addListeners(productTile.querySelectorAll(`.product-tile__unit-switch-radio`), `change`);
    // addQuantityChangeEvent;
    addListeners(productTile.querySelector(`.product-tile__qty-field`), `change`);
    // addQuantityButtonClickEvents;
    addListeners(productTile.querySelectorAll(`.product-tile__qty-switch--js-inc, .product-tile__qty-switch--js-dec`), `click`);
    // addShowGstOptionClickEvents;
    addListeners(win.document.querySelectorAll(`.view-menu__item--gst-option > [data-show-gst-option]`), `click`, true);
    // addShowPriceOptionClickEvents;
    addListeners(win.document.querySelectorAll(`.view-menu__item--price-option > [data-show-price-option]`), `click`, true);
  });
}